import { BenefitsEnrollmentStateEnum } from "@oysterhr/schema"

export const PER_PAGE = 15

export const ENROLLMENT_DISALLOWED_EDIT_STATES = new Set([
  BenefitsEnrollmentStateEnum.Finished,
  BenefitsEnrollmentStateEnum.ModifiedEnrollment,
  BenefitsEnrollmentStateEnum.OptedOut,
  BenefitsEnrollmentStateEnum.Cancelled,
])
